import axios from 'axios';
import { translate } from 'i18n/jhipster-language';
import { resolveTranslatedCmsApiErrorDetail, shouldSuppressCmsApiErrorToast, } from 'shared/lib/util/cms-api-error-message';
let toastRef = null;
/** Debounced like shahypay `axios-interceptor` so parallel failures do not stack identical toasts. */
let lastNetworkErrorToastAt = 0;
const NETWORK_ERROR_TOAST_MS = 5000;
export const setCmsApiErrorToastTarget = (instance) => {
    toastRef = instance;
};
export function showCmsApiErrorToast(error) {
    if (!toastRef?.show) {
        return;
    }
    if (axios.isCancel(error)) {
        return;
    }
    if (shouldSuppressCmsApiErrorToast(error)) {
        return;
    }
    let summary = translate('error.title');
    if (!summary?.trim?.() || summary === 'error.title') {
        summary = translate('form.apiErrorTitle');
    }
    const detail = resolveTranslatedCmsApiErrorDetail(error);
    const isLikelyNetwork = axios.isAxiosError(error) &&
        !error.response &&
        error.code !== 'ERR_CANCELED' &&
        !(typeof axios.isCancel === 'function' && axios.isCancel(error));
    if (isLikelyNetwork) {
        const now = Date.now();
        if (now - lastNetworkErrorToastAt < NETWORK_ERROR_TOAST_MS) {
            return;
        }
        lastNetworkErrorToastAt = now;
    }
    toastRef.show({
        severity: 'error',
        summary,
        detail,
        life: 9500,
        closable: true,
    });
}
